<template>
  <div class="myTable">
    <div class="searchNav" >
      <el-button class="newAdd" type="primary" @click="addShow()" icon="el-icon-plus" v-if="$can('customer-stat:add')">新增客户</el-button>
      <span><span class="searchNameStyle">客户类型：</span>
                <el-select v-model="searchInfo.type" clearable  @change="search" style="width: 150px;" placeholder="请选择">
                    <el-option
                            v-for="(item, i) in customersTypeList"
                            :key="i"
                            :label="item.value"
                            :value="item.value">
                    </el-option>
                </el-select>
            </span>
      <span><span class="searchNameStyle">客户名称 ：</span><el-input v-model="searchInfo.name" clearable placeholder="请输入" style="width: 150px;"></el-input></span>
      <span><span class="searchNameStyle">手机号码 ：</span><el-input v-model="searchInfo.phone" clearable placeholder="请输入" style="width: 150px;"></el-input></span>
      <span><span class="searchNameStyle">详细地址 ：</span><el-input v-model="searchInfo.address" clearable placeholder="请输入" style="width: 150px;"></el-input></span>
      <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick" >
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="type" label="客户类型" ></el-table-column>
        <el-table-column prop="name" label="客户名称" width="120"></el-table-column>
        <el-table-column prop="contactName" label="联系人" ></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="100" ></el-table-column>
        <el-table-column prop="threshold" label="阈值" ></el-table-column>
        <el-table-column prop="city" label="地区" width="100"></el-table-column>
        <el-table-column prop="address" label="详细地址" width="200" ></el-table-column>
        <el-table-column prop="telephoneNumber" label="固定电话" width="200" ></el-table-column>
        <el-table-column prop="employeeCount" label="用水人数" >
          <template slot-scope="scope">
            {{ scope.row.employeeCount ==""?0:scope.row.employeeCount }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"  ></el-table-column>
        <el-table-column prop="salesmanName" label="业务姓名" ></el-table-column>
        <el-table-column prop="salesmanPhone" label="业务号码" width="100" ></el-table-column>
        <el-table-column prop="devNum" label="绑定数量" ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('customer-stat:view')"  @click="moreInfo(scope.row)">详情</el-button>
            <el-button type="text" size="small" v-if="$can('customer-stat:edit')" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="$can('customer-stat:remove')" @click="confirmRemove(scope.row)">删除</el-button>
            <el-button type="text" size="small" v-if="$can('customer-stat:binding')" @click="deviceBinding(scope.row)">设备绑定</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="60%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form :model="addInfo" :rules="rules" ref="form" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="客户类型:" prop="type">
                      <el-select v-model="addInfo.type"  placeholder="请选择">
                        <el-option
                                v-for="item in customersTypeList"
                                :key="item.id"
                                :label="item.value"
                                :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名称:" prop="name">
                      <el-input v-model="addInfo.name" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="联系人:" prop="contactName">
                      <el-input v-model="addInfo.contactName" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="手机号码:" prop="phone">
                      <el-input v-model="addInfo.phone" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="固定电话:" >
                      <el-input v-model="addInfo.telephoneNumber" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
<!--                    <el-form-item label="用水人数:" >-->
<!--                      <el-input v-model="addInfo.employeeCount" placeholder="请输入" clearable></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="地区:" prop="district">
                      <div id="app">
                        <el-cascader
                                style="width: 300px;"
                                clearable
                                :options="options"
                                v-model="currentCity"
                                @change="handleChange">
                        </el-cascader>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item label="用水人数:" >
                        <el-input v-model="addInfo.employeeCount" placeholder="请输入" clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">

                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="详细地址:" prop="address">
                      <el-input v-model="addInfo.address" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="备注:" prop="remark">
                      <el-input v-model="addInfo.remark" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form>
            </div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">阈值设置</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form  :model="addInfo" :rules="rules1" ref="form1" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12" >
                    <el-form-item label="阈值:" prop="threshold" >
                      <el-input
                        v-model="addInfo.threshold"
                        placeholder="请输入小于25的阈值"
                        clearable
                        @input="validateThreshold">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">所属业务</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form :model="addInfo" :rules="rules2" ref="form2" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="业务姓名:" prop="authUserId">
                      <el-select v-model="addInfo.authUserId" placeholder="请选择" clearable>
                        <el-option
                                v-for="item in salesmanAndPartnerList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="业务号码:">
                      {{currentPhoneNumber}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
              title="详情"
              :visible.sync="moreInfoDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="客户类型：">
                      {{addInfo.type}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名称：">
                      {{addInfo.name}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用水人数：">
                      {{addInfo.employeeCount ==""?0:addInfo.employeeCount}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电话：">
                      {{addInfo.phone}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="地区：">
                      {{addInfo.city}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="详细地址：">
                      {{addInfo.address}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">所属业务</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form :model="addInfo" :rules="rules" ref="form" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="业务姓名:" prop="type">
                      <el-select v-model="addInfo.authUserId" disabled>
                        <el-option
                                v-for="item in salesmanAndPartnerList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="业务号码:">
                      {{currentPhoneNumber}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>

    <div>
      <el-dialog
              title="设备绑定"
              :visible.sync="deviceBindingDialogVisibleList"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">绑定设备信息</div>
            </div>
            <div style="margin-left: 15px;  padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
              <div style="text-align: right;margin-bottom: 10px; ">
                <el-button class="newAdd"  type="primary" @click="addForm" icon="el-icon-plus">绑定</el-button>
              </div>
              <div style="    min-height: 100px;" v-loading="tableLoading">
                <div style="padding: 10px; margin-bottom: 10px;" v-for="obj in deviceBindingList" :key="obj.id" >
                  <el-form label-width="100px">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="ICCID：">
                          {{obj.iccid}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="设备号：">
                          {{obj.imei}}
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
<!--                        <el-form-item label="阈值:" prop="threshold">-->
<!--                          {{obj.threshold}}-->
<!--                        </el-form-item>-->
                        <el-form-item label="绑定时间：">
                          {{obj.createTime}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="设置定时：" prop="configuredReportTime">
                          {{obj.configuredReportTime}}
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="24">
                        <el-form-item label="备注：">
                          {{obj.remark}}
                        </el-form-item>
                      </el-col>
                    </el-row>

                  </el-form>
                  <div style="text-align: right; margin-right: 20px;">
                    <button  style="background-color: rgb(64 158 255); color: white; border: none; padding: 6px 12px; cursor: pointer;margin-right: 10px;" @click="editDeviceBinding(obj)">编辑</button>
                    <button  style="background-color: rgb(133 134 136); color: white; border: none; padding: 6px 12px; cursor: pointer;" @click="removeDeviceBinding(obj)">解绑</button>
                  </div>
                </div>
              </div>
              <div v-if="deviceBindingList.length == 0" class="no-data"> 暂无绑定</div>
            </div>
          </div>
        </div>

      </el-dialog>

      <el-dialog
              title="设备绑定"
              :visible.sync="deviceBindingDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">基本信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="客户名称:" >
                      {{currentObj.name}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="业务人:" prop="name">
                      {{currentObj.salesmanName}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用水人数:" prop="contactName">
                      {{currentObj.employeeCount ==''?0:currentObj.employeeCount}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="手机号码:" prop="employeeCount">
                      {{currentObj.phone}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">设备信息</div>
            </div>
            <div  style="    margin-left: 15px;">
              <el-form label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item v-if="bindingInfo.id >0" label="设备号：">
                      <el-input v-model="bindingInfo.imei" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                    <el-form-item v-else label="设备号：">
                      <el-input v-model="bindingInfo.imei" placeholder="请输入" clearable @blur="getDevInfo"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-if="devInfo != null">
                  <el-col :span="24">
                    <el-form-item label="">
                      <div style="display: flex;color: #ccc;">
                        <div style="padding: 10px;"><span>主板型号：</span><span>{{devInfo.productModel}}</span></div>
                        <div style="padding: 10px;"><span>探头数量：</span><span>{{devInfo.serialPortNum}}</span></div>
                        <div style="padding: 10px;"><span>阈值：</span><span>{{devInfo.threshold}}</span></div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="设置定时：" prop="configuredReportTime">
                      <el-input v-model="bindingInfo.configuredReportTime" placeholder="间隔小时数" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="备注：">
                      <el-input v-model="bindingInfo.remark" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="deviceBindingDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveDeviceBinding">确 定</el-button>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import { regionData, codeToText, TextToCode } from 'element-china-area-data'

  export default {
    name: "white-list",
    data () {
      const vm = this; // 保存组件实例的引用
      return {
        dialogTitle:'新增客户',
        total:1,
        tableData: [],
        deviceBindingList: [],
        loading: false,
        dialogVisible: false,
        tableLoading: false,
        moreInfoDialogVisible: false,
        deviceBindingDialogVisibleList: false,
        deviceBindingDialogVisible: false,
        currentPage:1,
        customersTypeList:[], // 客户类型
        salesmanAndPartnerList:[], // 客户类型
        currentPhoneNumber:'',
        currentCity:[],
        addInfo:{
          name:'',
          employeeCount:'',
          threshold:'',
          telephoneNumber:'',
          phone:'',
          province:'',
          city:'',
          district:'',
          address:'',
          address:'',
          taxRate:'',
          email:'',
          finalPayment:'',
          contactName:'',
          remark:'',
          authUserId:'',
        },
        devInfo:null,
        bindingInfo:{
          customersId:'',
          imei:'',
          configuredReportTime:8,
          remark:'',
        },
        searchInfo:{
          name:'',
          type:'',
          employeeCount:'',
          phone:'',
          address:'',
          pageNumber:1,
          pageSize:50,
        },
        rules2:{
          authUserId: [
            { required: true, message: '请输选择', trigger: 'blur' }
          ],
        },
        rules1:{
          threshold: [
            { required: true, message: '请输输入', trigger: 'blur' },
            { validator: (rule, value, callback) => {
                if (value) {
                  const threshold = parseInt(value);
                  if (isNaN(threshold) || threshold.toString() !== value.toString()) {
                    callback(new Error('阈值必须为整数'));
                  } else if (threshold >= 25) {
                    callback(new Error('阈值必须小于25'));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              }, trigger: 'blur' }
          ],
        },
        rules: {
          type: [
            { required: true, message: '请输选择', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' }
          ],
          district: [
            { required: true, message: '请输入', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入电话', trigger: 'blur' },
            { validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请输入电话'));
                } else if (!vm.validatePhoneNumber(value)) {
                  callback(new Error('输入的固定电话格式有误，请修改！'));
                } else {
                  callback();
                }
              }, trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],
          contactName: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],

        },
        options: regionData,
        currentObj:{},
      }
    },
    watch: {
      'searchInfo.name'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.type'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.name'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.phone'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.address'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'addInfo.authUserId'(newVal,oldVal){
        if ("" == newVal){
          this.currentPhoneNumber = "";
        }
        this.salesmanAndPartnerList.forEach(item=>{
          if (item.id == newVal){
            this.currentPhoneNumber = item.account;
          }
        })
      },
    },
    created: function () {
      this.pageInfo();
      // this.getPaymentTermList();
      this.getCustomersTypeList();
      this.getSalesmanAndPartnerList();
    },
    methods:{
      search(){
        this.pageInfo();
      },
      //改为全局方法
      addShow(){
        this.clearObj(this.addInfo);
        this.dialogVisible = true;
        this.currentPhoneNumber = "";
        this.currentCity=[];
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      validate(){
        let flag = true;
        let msg  = "";

        // 验证阈值
        if (this.addInfo.threshold) {
          const threshold = parseInt(this.addInfo.threshold);
          if (isNaN(threshold) || threshold.toString() !== this.addInfo.threshold.toString()) {
            flag = false;
            msg = "阈值必须为整数";
          } else if (threshold >= 25) {
            flag = false;
            msg = "阈值必须小于25";
          }
        }

        return {code:flag,msg:msg}
      },
      saveDeviceBinding(){
        let validateObj = this.validate();
        if(typeof(this.bindingInfo.id)=== "undefined" || this.bindingInfo.id == ''){  // 绑定
          if (validateObj.code){
            axios.post('/devInfo/deviceBinding',this.bindingInfo).then(result => {
              if (result.code !== 200){
                console.log(result);
                this.msg("当前设备处于 "+result.message +" 状态，请更换其他的设备号。");
              }else {
                this.deviceBindingDialogVisible = false;
                this.getDeviceBindingList();
                this.pageInfo();
              }
            }).catch(err => {
              console.log(err);
            });
          }else{
            this.msg(validateObj.msg);
          }
        }else{  // 编辑
          if (validateObj.code){
            // 当前系列 是开启的
            axios.put('/devInfo/editDeviceBinding',this.bindingInfo).then(result => {
              this.deviceBindingDialogVisible = false;
              if (result.code !== 200){
                console.log(result);
              }
              this.pageInfo();
            }).catch(err => {
              console.log(err);
            });
          }else{
            this.msg(validateObj.msg);
          }
        }
      },
      save(){
        // 出去地区 数组转字符串
        this.addInfo.district = JSON.stringify(this.currentCity);
        console.info("=======",this.addInfo.district)
        // 创建一个 Promise 数组来存储所有的验证
        const validations = [
          new Promise(resolve => {
            this.$refs.form.validate(valid => {
              resolve(valid);
            });
          }),
          new Promise(resolve => {
            this.$refs.form1.validate(valid => {
              resolve(valid);
            });
          }),
          new Promise(resolve => {
            this.$refs.form2.validate(valid => {
              resolve(valid);
            });
          })
        ];

        // 等待所有验证完成
        Promise.all(validations).then(results => {
          // 检查所有验证是否都通过
          const allValid = results.every(valid => valid === true);

          if (allValid) {
            let validateObj = this.validate();
            if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
              if (validateObj.code){
                axios.post('/customers',this.addInfo).then(result => {
                  this.dialogVisible = false;
                  if (result.code !== 200){
                    console.log(result);
                  }
                  this.clearObj(this.addInfo); // 清空新增数据
                  this.pageInfo();
                }).catch(err => {
                  console.log(err);
                });
              }else{
                this.msg(validateObj.msg);
              }
            }else{  // 编辑
              if (validateObj.code){
                // 当前系列 是开启的
                axios.put('/customers',this.addInfo).then(result => {
                  this.dialogVisible = false;
                  if (result.code !== 200){
                    console.log(result);
                  }
                  this.pageInfo();
                  this.clearObj(this.addInfo); // 清空新增数据
                  this.addInfo.id = undefined;

                  this.dialogTitle="新增客户";
                }).catch(err => {
                  console.log(err);
                });
              }else{
                this.msg(validateObj.msg);
              }
            }
          } else {
            // 如果有验证未通过，显示错误提示
            this.$message({
              message: '请完善必填信息',
              type: 'warning'
            });
            return false;
          }
        });
      },
      remove(id){
        axios.delete('/customers',{data: {id:id}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.pageInfo();
        })
      },
      unbinding(obj){
        console.info("obj:",obj);
        axios.delete('/devInfo/unbinding',{data: {id:obj.id,devId:obj.deviceStatusId}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.getDeviceBindingList();
          this.pageInfo();
        })
      },
      deviceBinding(obj){
        // 查询绑定的设备 deviceBindingList
        //显示弹出
        this.deviceBindingDialogVisibleList = true;
        this.currentObj = obj;
        this.bindingInfo.customersId = obj.id;
        this.getDeviceBindingList();
      },
      getDevInfo(){
        // 查询绑定的设备 deviceBindingList
        axios.get('/devInfo/byImei',{
          params: {imei:this.bindingInfo.imei}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.devInfo = result.data;
          console.log("devInfo:",this.devInfo);
        }).catch(err => {
          console.log(err);
        });
      },
      getDeviceBindingList(){
        // 查询绑定的设备 deviceBindingList
        axios.get('/devInfo/byCustomersId',{
          params: {customersId:this.bindingInfo.customersId}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.deviceBindingList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },

      addForm(){
        //显示弹出
        this.deviceBindingDialogVisible = true;
        this.bindingInfo.imei = "";
        this.bindingInfo.remark = "";
        this.devInfo = null;
      },
      editDeviceBinding(obj){
        this.deviceBindingDialogVisible = true;
        console.info("obj:",obj);
        this.bindingInfo = JSON.parse(JSON.stringify(obj));
      },
      confirmRemove(obj){
        if (obj.devNum == ""){ // 表示绑定设备数 等于 0 可以删除
          this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.remove(obj.id);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else { // 提示不能删除
          this.$alert('<strong>当前客户还有绑定设备，请先解绑设备，再删除客户。</strong>', '提示', {
            dangerouslyUseHTMLString: true
          });
        }

      },

      removeDeviceBinding(obj){
        this.$confirm('确定解绑?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbinding(obj);
          this.$message({
            type: 'success',
            message: '解绑成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      edit(obj){
        this.dialogTitle = "客户编辑";
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.dialogVisible = true;
        this.salesmanAndPartnerList.forEach(item=>{
          if (item.id == obj.authUserId){
            this.currentPhoneNumber = item.account;
          }
        })
        // 处理地区 将字符串转数组
        this.currentCity = JSON.parse(this.addInfo.district);
      },
      moreInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.moreInfoDialogVisible = true;
        //.getContactsLists(this.addInfo.id);
      },
      handleRowDblClick(row, column, event) {
        this.addInfo =JSON.parse(JSON.stringify(row));
        this.moreInfoDialogVisible = true;
        //this.getContactsLists(this.addInfo.id);
      },
      confirmChangeState(obj){
        let operation = obj.enabled?"禁用":"开启";
        this.$confirm('确定要'+operation+obj.account+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeState(obj.id);
          this.$message({
            type: 'success',
            message: operation+'成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'+operation
          });
        });
      },
      changeState(id){
        axios.put("/user/disable",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      resetPassword(id){
        axios.put("/user/reset",{id:id}).then(res => {
          if (res.code !== 200){
            console.log(res);
          }
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
        })
      },
      pageInfo(){
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/customers',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;

          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },

      getCustomersTypeList(){
        axios.get('/dict/code',{
          params: {code:102}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.customersTypeList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
      getSalesmanAndPartnerList(){
        axios.get('/user/salesmanAndPartnerList',{
          params: {}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.salesmanAndPartnerList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
      // 在获取详情信息接口中使用 TextToCode 将字符串转换成编码赋给
      handleChange (value) {
        console.log(value)
        let numberArray = value.map(Number);
        this.getCodeToText(null, numberArray)
      },
      getCodeToText (codeStr, codeArray) {
        if (null === codeStr && null === codeArray) {
          return null;
        } else if (null === codeArray) {
          codeArray = codeStr.split(",");
        }
        let area = "";
        switch (codeArray.length) {
          case 1:
            area += codeToText[codeArray[0]];
            break;
          case 2:
            area += codeToText[codeArray[0]] + "/" + codeToText[codeArray[1]];
            break;
          case 3:
            area +=
                    codeToText[codeArray[0]] +
                    "/" +
                    codeToText[codeArray[1]] +
                    "/" +
                    codeToText[codeArray[2]];
            break;
          default:
            break;
        }
        console.log(area)
        this.addInfo.city = area
        return area;
      },
      validateThreshold(value) {
        if (value) {
          const threshold = parseInt(value);
          if (isNaN(threshold) || threshold.toString() !== value.toString()) {
            this.$message.warning('阈值必须为整数');
            this.addInfo.threshold = '';
          } else if (threshold >= 25) {
            this.$message.warning('阈值必须小于25');
            this.addInfo.threshold = '';
          }
        }
      },
    },filters: {
      showState(val){
        if (val){
          return "可用";
        }
        return "不可用"
      },
      showVehicleType(val){
        if (val){
          return "车头";
        }
        return "挂车"
      },
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
  /deep/ #contentStyle .el-form-item__content{
    margin-left:0 !important;
  }
  .connectTitleStyle{
    display: flex;
    justify-content: space-between;
    background: #f6f8fc;
    margin-left: 15px;
  }

  /deep/ #connectInfoStyle .el-table{
    .el-table__body-wrapper{
      height: auto; overflow-y: auto;
    }
  }

</style>
